function EmbeddedMap() {
  return (
    <div style={{ width: '100%', height: '400px' }}>
      <iframe
        title="Google Map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3469.873724488514!2d-98.5147466!3d29.578277200000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x865c6186f0ad80ab%3A0x115b8176d14fdf0!2sAspire%20BHP!5e0!3m2!1sen!2sus!4v1754705595378!5m2!1sen!2sus"
        width="100%"
        height="100%"
        style={{ border: '2px solid #3a4c17', borderRadius: '8px' }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  );
}

export default EmbeddedMap;